export default __webpack_public_path__ + "static/media/whatsapp.e5cc8be9.svg";